import React, { FC } from 'react';

import { PageTitle, PageWrapper } from '../../../components';
import { useWarmup } from '../../../hooks';
import { CreateOrganizationWizard } from '../components';

export const CreateOrganization: FC = () => {
  useWarmup(['v3-createOrganization', 'v3-checkDomainAvailability']);
  return (
    <PageWrapper>
      <PageTitle title="Create Organization" />
      <CreateOrganizationWizard />
    </PageWrapper>
  );
};
